import { render } from "./Press.vue?vue&type=template&id=283a6bbd&scoped=true"
import script from "./Press.vue?vue&type=script&lang=js"
export * from "./Press.vue?vue&type=script&lang=js"

import "./Press.vue?vue&type=style&index=0&id=283a6bbd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283a6bbd"]])

export default __exports__